import { render, staticRenderFns } from "./AdvIcon.vue?vue&type=template&id=20845d7e&"
import script from "./AdvIcon.vue?vue&type=script&lang=js&"
export * from "./AdvIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports